(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.headerBounds = { top: 0, bottom: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('scroll', this.onScroll);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _start() {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const h = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBounds = { top: rect.top + scrollTop, bottom: rect.bottom + scrollTop };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const hb = this.headerBounds;
    const eps = this.THRESHOLD_EPS;

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('scroll', this.onScroll);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _start() {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = document.querySelector('.shopify-section-header');
    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const h = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBounds = { top: rect.top + scrollTop, bottom: rect.bottom + scrollTop };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const hb = this.headerBounds;
    const eps = this.THRESHOLD_EPS;

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();
})();
